import {getPurchaseMlSummaryLines} from "../../../../../common/address-lists/get-purchase-ml-summary-lines";
import {summaryLines}              from "../common/summary-lines-expo";

export const addressListsSummary = ({templateOptions, mailingLists}) => [
    {
        load: ({addressLists1, addressLists2, enableAddressableShippingLogic2, method, mailingClass2}, next) => next(addressLists2 && {
            summaryLines: mailingClass2?.mailingClassId === "5" ? [] : getPurchaseMlSummaryLines({
                templateOptions,
                mailingLists: mailingLists?.filter((al) => (
                    addressLists1.state.value?.some((id) => id == al.id)
                )),
                isMailing: ["mailing", "mail"].includes(method),
                isAddressableShipping: enableAddressableShippingLogic2?.state.value,
            }),
        }),
        requires: ["addressLists1", "addressLists2", "enableAddressableShippingLogic2", "method", "mailingClass2"],
        expo: [summaryLines],
    },
];


